import React, { useState, useEffect } from "react";
import "./dashboard.css";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import axios from "axios";
import Navb from "../../components/navbar/Navb";
import Arrow from "./arrow.svg";
import SideBar from "./SideBar";
import API_URL from "../../constants";
const Dashboard = () => {
  const [jobs, setJobs] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [sortBy, setSortBy] = useState("createdAt"); // Default sort by Date Posted
  const [sortOrder, setSortOrder] = useState("desc"); // Default sort order descending
  const [jobsId, setJobsId] = useState();
  const [editingJobId, setEditingJobId] = useState(null);
  const [submit, setSubmit] = useState(false);
  const [candidate, setCandidate] = useState([]);
  const [formData, setFormData] = useState({});
  const [status, setStatus] = useState("active");
  // const [selectedStatus, setSelectedStatus] = useState("active");
// console.log("log",API_URL);
  // const handleStatusChange = (status) => {
  //   setSelectedStatus(status);
  // };

  useEffect(() => {
    fetchData(status);
  }, [status]);

  useEffect(() => {
    console.log("Candidate", candidate);
  }, [candidate]);

  const fetchData = async (statusvalue) => {
    try {
      const status = {
        status: statusvalue,
      };
      const response = await axios.get(`${API_URL}/admin/jobs`, {
        params: status,
      });
      console.log("response", response);
      setJobs(response.data.jobs);
    } catch (error) {
      console.error("Error:", error);
    }
  };
  const handleStatusChange = (newStatus) => {
    setStatus(newStatus); // Update the status state variable
  };

  const handleEditClick = (jobId) => {
    const jobToEdit = jobs.find((job) => job.job_id === jobId);
    setFormData(jobToEdit);
    setEditingJobId(jobId);
  };
  const handleCandidatesClick = async (jobId) => {
    try {
      const status = {
        status: "all",
      };
      const resp = await axios.get(
        `${API_URL}/admin/jobs/${jobId}/candidates`,
        { params: status }
      );
      console.log("resp:", resp);
      // setCandidate(resp.data.candidates);
      setCandidate(resp.data.candidates);
      setJobsId(jobId);
    } catch (error) {
      console.error("Error:", error.request);
    }
  };
  const handleCancelClick = (jobId) => {
    setEditingJobId(null);
  };

  const handleSubmit = async () => {
    console.log("formData", formData);
    const { id, job_id, updatedAt, createdAt, ...formDataWithoutTimestamps } =
      formData;

    const dataToChange = { ...formDataWithoutTimestamps };
    try {
      const resp = await axios.post(
        `${API_URL}/admin/jobs/${editingJobId}`,
        dataToChange
      );
      console.log("resp:", resp);
      setSubmit(true);
    } catch (error) {
      if (error.response) {
        // The server returned an error response
        console.error("Server Error:", error.response.data);
        console.error("Status Code:", error.response.status);
      } else if (error.request) {
        // The request was made but no response was received
        console.error("Network Error:", error.request);
      } else {
        // Something happened in setting up the request that triggered an error
        console.error("Request Error:", error.message);
      }
    }
    console.log("formData", formData);
    console.log("editingJobId", editingJobId);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    console.log("Updated form data:", { ...formData, [name]: value });
  };
  const handleCreateChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleCreateSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${API_URL}/admin/create_jobs`,
        formData
      );
      console.log("Job created successfully:", response.data);
      // Optionally, you can reset the form after submission
      setFormData({
        company_name: "",
        job_description: "",
        location: "",
        openings: "",
        post: "",
        remote: "",
        salary_offered: "",
        skills: "",
        status: "",
      });
      fetchData();
    } catch (error) {
      console.error("Error creating job:", error);
    }
  };
  //   // Pagination Logic
  //   const indexOfLastJob = currentPage * itemsPerPage;
  //   const indexOfFirstJob = indexOfLastJob - itemsPerPage;
  //   const currentJobs = jobs.slice(indexOfFirstJob, indexOfLastJob);

  //   const paginate = (pageNumber) => setCurrentPage(pageNumber);
  //   const totalJobs = jobs.length;
  //   const totalPages = Math.ceil(totalJobs / itemsPerPage);

  // // Function to handle sorting
  // const handleSort = (criteria) => {
  //   if (sortBy === criteria) {
  //     // If the same criteria is clicked, toggle the sort order
  //     setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
  //   } else {
  //     // If a different criteria is clicked, set the new criteria and default to descending order
  //     setSortBy(criteria);
  //     setSortOrder('desc');
  //   }
  // };

  // // Function to sort jobs based on selected criteria and order
  // const sortedJobs = [...jobs].sort((a, b) => {
  //   if (sortBy === 'applicantCount') {
  //     return sortOrder === 'asc' ? a.applicantCount - b.applicantCount : b.applicantCount - a.applicantCount;
  //   } else if (sortBy === 'salary_offered') {
  //     return sortOrder === 'asc' ? a.salary_offered - b.salary_offered : b.salary_offered - a.salary_offered;
  //   } else {
  //     // Default to sorting by createdAt (Date Posted)
  //     return sortOrder === 'asc' ? new Date(a.createdAt) - new Date(b.createdAt) : new Date(b.createdAt) - new Date(a.createdAt);
  //   }
  // });
  const handleSort = (criteria) => {
    if (sortBy === criteria) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortBy(criteria);
      setSortOrder("desc");
    }
    setCurrentPage(1);
  };

  const sortedJobs = [...jobs].sort((a, b) => {
    if (sortBy === "applicantCount") {
      return sortOrder === "asc"
        ? a.applicantCount - b.applicantCount
        : b.applicantCount - a.applicantCount;
    } else if (sortBy === "salary_offered") {
      return sortOrder === "asc"
        ? a.salary_offered - b.salary_offered
        : b.salary_offered - a.salary_offered;
    } else {
      return sortOrder === "asc"
        ? new Date(a.createdAt) - new Date(b.createdAt)
        : new Date(b.createdAt) - new Date(a.createdAt);
    }
  });

  const indexOfLastJob = currentPage * itemsPerPage;
  const indexOfFirstJob = indexOfLastJob - itemsPerPage;
  const currentJobs = sortedJobs.slice(indexOfFirstJob, indexOfLastJob);

  const totalJobs = sortedJobs.length;
  const totalPages = Math.ceil(totalJobs / itemsPerPage);

  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  return (
    <>
      <Navb />
      <div className="dashboard">
        <SideBar />
        <section className="rightBar">
          <div className="center filters ">
            <div>
              <button
                className={status === "active" ? "selected" : "notSelected"}
                onClick={() => handleStatusChange("active")}
              >
                Active
              </button>
              <button
                className={status === "closed" ? "selected" : "notSelected"}
                onClick={() => handleStatusChange("closed")}
              >
                Closed
              </button>
              <button
                className={status === "draft" ? "selected" : "notSelected"}
                onClick={() => handleStatusChange("draft")}
              >
                Draft
              </button>
            </div>
            <div>
              <label style={{"font-weight":"500","font-size": "18px"}}>
                Sort By :
                <select
                // className="form-select"
                  value={sortBy}
                  onChange={(e) => handleSort(e.target.value)}
                >
                  <option value="createdAt">Date Posted</option>
                  <option value="applicantCount">Number of Applicants</option>
                  <option value="salary_offered">Salary Offered</option>
                </select>
              </label>
              <label className="measurement">
                <input
                  type="radio"
                  value="asc"
                  checked={sortOrder === "asc"}
                  onChange={() => setSortOrder("asc")}
                />{" "}
                Ascending
              </label>
              <label className="measurement">
                <input
                  type="radio"
                  value="desc"
                  checked={sortOrder === "desc"}
                  onChange={() => setSortOrder("desc")}
                />{" "}
                Descending
              </label>
            </div>
          </div>
          <div>
            {currentJobs && currentJobs.length > 0 && (
              <table>
                <thead>
                  <tr>
                    <th>Title</th>
                    <th>Company</th>
                    <th>Date Posted</th>
                    <th>Applicants</th>
                    <th>jobs Detail</th>
                    <th>jobs candidates</th>
                    {/* This is for the right arrow icon */}
                  </tr>
                </thead>
                <tbody>
                  {currentJobs.map((job, index) => (
                    <tr key={index}>
                      <td
                        style={{
                          "min-width": "14rem",
                          "border-radius": "10px 0px 0px 10px",
                        }}
                      >
                        {job.post}
                      </td>
                      <td style={{ "min-width": "14rem" }}>
                        {job.company_name}
                      </td>
                      <td>
                        {new Date(job.createdAt).toLocaleDateString("en-US", {
                          month: "long",
                          day: "2-digit",
                          year: "numeric",
                        })}
                      </td>
                      <td>{job.applicantCount}</td>
                      <td style={{
                          "min-width": "8rem"
                        }}>
                        <a href={`/dashboard/view_jobs/${job.job_id}`}>
                          <img src={Arrow} alt="Arrow" />
                        </a>
                      </td>
                      <td style={{ "border-radius": "0px 10px 10px 0px" }}>
                        <a
                          href={`/dashboard/view_jobs_candidates/${job.job_id}`}
                        >
                          <img src={Arrow} alt="Arrow" />
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
          <div className="pagination ">
            <p>
              Page {currentPage} of {totalPages}
            </p>
            <div className="paginationbut">
              <button
                onClick={() => paginate(currentPage - 1)}
                disabled={currentPage === 1}
              >
                Previous
              </button>
              <button
                onClick={() => paginate(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Dashboard;
